import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-mu-form-buttons',
  templateUrl: './mu-form-buttons.component.html',
  styleUrls: ['./mu-form-buttons.component.sass'],
})
export class MuFormButtonsComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() customGridCol: number;
  @Input() alwaysFullWidth: boolean;
  @HostBinding('class') baseClass = 'p-col-12 mu-without-padding';

  constructor() {
    /** */
  }

  ngOnInit(): void {
    /** */
  }
}
